module.exports = __webpack_public_path__ + "img/xmk.4dd1d040.png";